import { useMemo } from 'react';
import { getActionStateConfiguration } from '../../../helpers/getStateConfiguration';
import { useTranslation } from 'react-i18next';
import './State.scss';
import { ActionType } from '../../../types/ActionType';

function ActionState({
	actionState,
	size,
	isMerchant = false,
}: {
	actionState: ActionType;
	size: 'big' | 'small';
	isMerchant?: boolean;
}) {
	const { t } = useTranslation();
	const stateConfig = useMemo(
		() => getActionStateConfiguration(actionState, t, isMerchant),
		[t, actionState, isMerchant],
	);

	return (
		<span
			className='state'
			style={{
				color: stateConfig.color,
				backgroundColor: stateConfig.bgColor,
				border: 'none',
				fontSize: size === 'small' ? '10px' : '14px',
				marginBottom: '4px',
			}}
		>
			{stateConfig.label}
		</span>
	);
}

export default ActionState;
